const getEnv = (key) => process.env[key] || '';

export const auth0Config = {
    domain: getEnv('REACT_APP_AUTH0_DOMAIN'),
    clientId: getEnv('REACT_APP_AUTH0_CLIENT_ID'),
    audience: getEnv('REACT_APP_AUTH0_AUDIENCE'),
    namespace: getEnv('REACT_APP_AUTH0_NAMESPACE') || 'https://thesustainabilityacademy.co.uk/' || 'https://your-app.com/',
    scope: getEnv('REACT_APP_AUTH0_SCOPE') || 'openid profile email',
    redirectUri: getEnv('REACT_APP_AUTH0_REDIRECT_URI') || window.location.origin
};

export const isAuth0Configured = () => Boolean(auth0Config.domain && auth0Config.clientId);